export const GET_APPLICANTS_EXPORT_REQUEST = "GET_APPLICANTS_EXPORT_REQUEST";
export const GET_APPLICANTS_EXPORT_RESPONSE = "GET_APPLICANTS_EXPORT_RESPONSE";
